import { Box, Button, Collapse, Fade, Typography } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

/**
 * emptyType:
 *  - "FILTERED" → user applied filters
 *  - "FRESH"    → no orders at all
 */
const COPY = {
  FILTERED: {
    icon: <SearchOffOutlinedIcon />,
    title: "No matching orders",
    subtitle: "Try changing the date range or clearing filters.",
  },
  FRESH: {
    icon: <ReceiptLongOutlinedIcon />,
    title: "No orders yet",
    subtitle: "Orders created will appear here once billing starts.",
  },
};

const HistoryEmptyState = ({
  emptyType = "FILTERED",
  showCreate = true,
  onResetFilter,
  onCreateOrder,
}) => {
  const { icon, title, subtitle } = COPY[emptyType];

  return (
    <Collapse in timeout={220}>
      <Fade in timeout={220}>
        <Box
          minHeight={320}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            textAlign="center"
            sx={{
              px: 3,
              maxWidth: 420,
              color: "text.secondary",
            }}
          >
            {/* Icon */}
            <Box
              sx={{
                fontSize: 64,
                mb: 2,
                opacity: 0.6,
                display: "flex",
                justifyContent: "center",
              }}
            >
              {icon}
            </Box>

            {/* Title */}
            <Typography
              variant="h6"
              color="text.primary"
              sx={{ fontWeight: 600 }}
            >
              {title}
            </Typography>

            {/* Subtitle */}
            <Typography variant="body2" sx={{ mt: 1, mb: 3 }}>
              {subtitle}
            </Typography>

            {/* Actions */}
            <Box display="flex" justifyContent="center" gap={2}>
              {emptyType === "FILTERED" && onResetFilter && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={onResetFilter}
                >
                  Clear Filters
                </Button>
              )}

              {emptyType === "FRESH" && showCreate && onCreateOrder && (
                <Button
                  variant="contained"
                  size="small"
                  onClick={onCreateOrder}
                >
                  Create First Order
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Fade>
    </Collapse>
  );
};

export default HistoryEmptyState;
